export const routesList = {
  homePage: "/",
  mint: "/mint",
  token_registration: "/registration",
  token_holder: "/tokenHolder",
  baby_mint: "/babyMint",
  super_baby_mint: "/superBabyMint",
  utilities: "/utilities",
};

export const urls = {
  homePage: routesList.homePage,
  mint: routesList.mint,
  token_registration: routesList.token_registration,
  token_holder: routesList.token_holder,
  baby_mint:routesList.baby_mint,
  super_baby_mint: routesList.super_baby_mint,
  utilities:routesList.utilities,  
};

export const labels = {
  mint: "Mint NFT",
  connect_wallet: "Connect Wallet",
  token_registration: "Token Registration",
  token_holder: "Token Holder",
  token_holder_area: "Token Holders Area",
  baby_mint:"Make Baby",
  super_baby_mint: "Make Super Baby",
  utilities:"Utilities",
  super_baby_mint:"Manifest Super Baby"
};

export const hashSections = {
  aboutUs: "/#aboutus",
  roadmap: "/#roadmap",
  team: "/#team"
};

export const hashSectionsAs = {
  aboutUs: "#aboutus",
  roadmap: "#roadmap",
  team: "#team"
};
